import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramBillingPage } from './program-billing';

@NgModule({
  declarations: [
    ProgramBillingPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramBillingPage),
  ],
})
export class ProgramBillingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-billing/program-billing.module.ts